import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PsDatepickerDirective } from './psdatepicker.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [PsDatepickerDirective],
  exports: [PsDatepickerDirective]
})
export class PsDatepickerModule { }



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/pf.core/datepicker/psdatepicker.module.ts